const RING = { size: 76, stroke: 8 };
const RADIUS = (RING.size - RING.stroke) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const CENTER = RING.size / 2;

/**
 * The gauge of the goal, cut like the ring of « Appels du jour » (CallsRing):
 * the orange arc on its pale blue track, the count in its centre.
 */
const GoalRing = ({ value, goal }) => {
  const ratio = goal > 0 ? Math.min(1, value / goal) : 0;
  const circle = {
    cx: CENTER,
    cy: CENTER,
    r: RADIUS,
    fill: 'none',
    strokeWidth: RING.stroke,
  };
  return (
    <div className="relative flex size-[76px] shrink-0 items-center justify-center">
      <svg
        viewBox={`0 0 ${RING.size} ${RING.size}`}
        className="absolute inset-0 -rotate-90"
        aria-hidden="true"
      >
        <circle {...circle} className="stroke-blue-200" />
        {ratio > 0 && (
          <circle
            {...circle}
            strokeLinecap="round"
            strokeDasharray={`${ratio * CIRCUMFERENCE} ${CIRCUMFERENCE}`}
            className="stroke-yellow-500"
          />
        )}
      </svg>
      <span className="relative flex items-end">
        <span className="text-xl font-bold leading-7 text-gray-900">
          {value}
        </span>
        <span className="text-sm font-medium leading-5 text-gray-600">
          /{goal}
        </span>
      </span>
    </div>
  );
};

export default GoalRing;
